import { render, staticRenderFns } from "./DocumentosAdministracao.vue?vue&type=template&id=442b3432&scoped=true"
import script from "./DocumentosAdministracao.vue?vue&type=script&lang=js"
export * from "./DocumentosAdministracao.vue?vue&type=script&lang=js"
import style0 from "./DocumentosAdministracao.vue?vue&type=style&index=0&id=442b3432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b3432",
  null
  
)

export default component.exports